import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setSourceInvestmentIdAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (event.type !== "CAPITAL_MEASURE_SELECTED")
    throw new Error(`Invalid event type ${event.type}`);

  return {
    investmentValues: {
      depotId: context.investmentValues.depotId,
      investmentCurrency: context.investmentValues.investmentCurrency,
    },
    sourceInvestmentValues: {
      id: context.investmentValues.id,
      name: context.investmentValues.name,
    },
  };
};
